import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class HoursService {
  generateTimeArray(startHour: number, endHour: number, interval: number): string[] {
    const times: string[] = [];
    for (let hour = startHour; hour <= endHour; hour++) {
      for (let minute = 0; minute < 60; minute += interval) {
        const formattedHour = this.formatNumber(hour);
        const formattedMinute = this.formatNumber(minute);
        times.push(`${formattedHour}:${formattedMinute}`);
      }
    }
    return times;
  }
  
  private formatNumber(num: number): string {
    return num < 10 ? '0' + num : num.toString();
  }
}